var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
import '../components/product-added-modal';
import cart from '../services/cart';
let SelectGift = class SelectGift extends LitElement {
    constructor() {
        super();
        this.sku = '';
        this.ruleId = 0;
        this.actionIndex = 0;
        this.multiplier = 1;
        this.index = 0;
        this.error = null;
        this.errorHideTimeout = null;
        this.addedHideTimeout = null;
        this.addEventListener('click', () => {
            this.add().catch((err) => {
                console.error('Failed to handle click', err);
            });
        });
    }
    static get styles() {
        return css `
            :host {
                position: relative;
                user-select: none;
                height: 100%;
                background-color: var(--color-important-accents);
                color: #fff;
                text-align: center;
                font-weight: bold;
                display: block;
                padding: 0 1em;
                margin: 0;
                width: auto;
                cursor: pointer;
                transition: background-color 0.3s ease-out;
            }
            @media (any-hover) {
                :host(:hover) {
                    background-color: var(--color-important-accents-dark);
                }
            }
        `;
    }
    render() {
        return html `
            <div>
                <slot></slot>
            </div>
        `;
    }
    async add() {
        await cart.selectGift(this.ruleId, this.actionIndex, this.multiplier, this.index);
    }
};
__decorate([
    property({ type: String })
], SelectGift.prototype, "sku", void 0);
__decorate([
    property({ type: Number })
], SelectGift.prototype, "ruleId", void 0);
__decorate([
    property({ type: Number })
], SelectGift.prototype, "actionIndex", void 0);
__decorate([
    property({ type: Number })
], SelectGift.prototype, "multiplier", void 0);
__decorate([
    property({ type: Number })
], SelectGift.prototype, "index", void 0);
__decorate([
    property({ type: String })
], SelectGift.prototype, "error", void 0);
SelectGift = __decorate([
    customElement('select-gift')
], SelectGift);
export default SelectGift;
